import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Collection } from '../Models/collection';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class CollectionService {

  constructor(private http: HttpClient,
              private config: Config,
              private languageService: LanguageService) { }

  list(): Observable<Collection[]> {
    // collections depend on language hence the flatmap
    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<Collection[]>(this.config.getURL('collections'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/collection.ts